import React from 'react';
import '../App.css';
import { useLocation } from 'react-router-dom';

const ErrorPage = () => {
    const location = useLocation()
    const {
        header: stateHeader,
        message: stateMessage,
        linkPrefix,
        linkText,
        linkHref: stateLinkHref,
        linkSuffix,
        logo: stateLogo,
    } = location.state || {}

    const link = stateLinkHref?.toLowerCase() || ""
    const isVacation =
        (link.includes("logo_vacation") || link.includes("vacation.com")) && !link.includes("dreamvacations")

    const headerBgColor = isVacation ? "#33c590" : "white"

    const hostname =
        typeof window !== "undefined" && window.location && window.location.hostname
            ? window.location.hostname.toLowerCase()
            : ""

    // Default (Travel Leaders)
    let brandLogoSrc = "https://agents.travelleaders.com/Reviews/images/LogoTL_59.png"
    let brandLogoLink = "https://travelleaders.com"
    let brandContactLink = "https://www.travelleaders.com/contact_us"
    let brandHeaderColor = "white"

    if (hostname.includes("travelleaders.com")) {
        brandLogoSrc = "https://agents.travelleaders.com/Reviews/images/LogoTL_59.png"
        brandLogoLink = "https://travelleaders.com"
        brandContactLink = "https://www.travelleaders.com/contact_us"
        brandHeaderColor = "white"
    }

    // Dream Vacations
    if (hostname.includes("dreamvacationsagentdirectory.com")) {
        brandLogoSrc =
            "https://www.dreamvacations.com/images/home-based/webresources/images/logos/dream-vacations-logo-color.svg"
        brandLogoLink = "https://travelagents.dreamvacations.com/home"
        brandContactLink = "https://www.dreamvacations.com/vacation/contact/get-in-touch"
        brandHeaderColor = "white"
    }

    // Cruise One
    if (hostname.includes("cruiseoneagentdirectory.com")) {
        brandLogoSrc = "https://www.cruiseone.com/images/home-based/webresources/images/logos/cruise-one-logo-color.svg"
        brandLogoLink = "https://travelagents.cruiseone.com/home"
        brandContactLink = "https://www.cruiseone.com/vacation/contact/get-in-touch"
        brandHeaderColor = "white"
    }

    if (hostname.includes("globaltravelcollection.com")) {
        brandLogoSrc = "https://www.globaltravelcollection.com/images/logo-GTC-black.svg"
        brandLogoLink = "https://www.globaltravelcollection.com"
        brandContactLink = "https://www.globaltravelcollection.com/about-gtc#contact-us"
        brandHeaderColor = "white"
    }

    // Altour
    if (hostname.includes("altour.com")) {
        brandLogoSrc =
            "https://altour.com/wp-content/uploads/elementor/thumbs/Altour-Brandmark-Altour-Navy-1-r9hafn8vh538sbg98kylidd1rciw36snt8edyg2fz0.png"
        brandLogoLink = "https://www.altour.com"
        brandContactLink = "https://www.altour.com/contact"
        brandHeaderColor = "white"
    }

    // Barrhead
    if (hostname.includes("barrhead.com")) {
        brandLogoSrc =
            "https://www.barrheadtravel.co.uk/media/20699/logo.png?width=229&height=30&center=0.5%2c0.5&quality=80"
        brandLogoLink = "https://www.barrheadtravel.co.uk/"
        brandContactLink = "https://www.barrheadtravel.co.uk/contact-us"
        brandHeaderColor = "white"
    }

    const finalHeaderColor = isVacation ? "#33c590" : brandHeaderColor || headerBgColor || "white"
    const finalLogoSrc = stateLogo || brandLogoSrc
    const finalLogoLink =
        hostname.includes("dreamvacationsagentdirectory.com") || hostname.includes("cruiseoneagentdirectory.com")
            ? brandLogoLink
            : stateLinkHref || brandLogoLink
    const finalContactLink = stateLinkHref || brandContactLink

    const isDefaultMessage = !stateMessage || stateMessage.trim() === "" || stateMessage.toLowerCase() === "default"

    const displayMessage =
        stateMessage && stateMessage.trim() !== "" && stateMessage.toLowerCase() !== "default" ? stateMessage : null

    return (
        <div className="ErrorPage">
            <header className="shadow-md p-10 text-left relative" style={{ backgroundColor: finalHeaderColor }}>
                <a href={finalLogoLink} rel="noopener noreferrer" target="_blank">
                    <img src={finalLogoSrc || "/placeholder.svg"} alt="Brand Logo" className="max-h-16 inline-block" />
                </a>
            </header>

            <div
                className="bg-white shadow-md p-20 mt-24 mb-10 w-11-12 mx-auto text-center relative"
                style={{ maxWidth: "42rem" }}
            >
                <div className="relative">
                    <h1 className="text-3xl mb-2 pb-4 text-tlBlue">{stateHeader || "Oops! Something went wrong."}</h1>
                    <h2 className="text-lg mb-2">
                        {displayMessage && (
                            <div
                                className="text-lg mb-2"
                                dangerouslySetInnerHTML={{
                                    __html: displayMessage.replace(
                                        /<a /g,
                                        '<a class="text-tlBlue" style="text-decoration: none;" '
                                    ),
                                }}
                            />
                        )}

                        {isDefaultMessage && (
                            <>
                                <br />
                                Please try again in a few minutes.
                                <br />
                                If the error persists,{" "}
                                <a
                                    className="text-lg mb-2 text-tlBlue underline"
                                    href={location.state?.contactLink || finalContactLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    id="lnkFindAgents"
                                >
                                    please contact us
                                </a>
                                .
                            </>
                        )}

                        {linkPrefix && `${linkPrefix} `}
                        {linkSuffix && ` ${linkSuffix}`}
                    </h2>
                </div>
            </div>
        </div>
    )
}

export default ErrorPage